import PropTypes from "prop-types";
import Modal from "@shared/v2/Modal";
import useConferenceConfirmation from "./useConferenceConfirmation";
import {
  ConferenceConfirmationActions,
  ConferenceConfirmationBody,
  ConferenceConfirmationDescription,
} from "./ConferenceConfirmationShared";

const ConfirmationModal = ({
  selectedLeadUuids,
  closeConfirmationModal,
  createDialerSession,
  show,
  isLoading,
}) => {
  const {
    consentChecked,
    featureFlags,
    isAdmin,
    loadingValidLeads,
    outboundNotificationMessage,
    outboundNotificationMessageCondition,
    outboundRecording,
    outboundRecordingEnabled,
    setConsentChecked,
    startDisabled,
    validLeadCounts,
  } = useConferenceConfirmation({ selectedLeadUuids, show });

  return (
    <Modal
      show={show}
      dialogClassName="tw-flex tw-items-center tw-justify-center tw-h-full"
      contentClassName="tw-m-auto tw-flex tw-flex-col tw-gap-[32px] tw-max-w-[657px] tw-w-full tw-max-h-[90vh]"
      onHide={closeConfirmationModal}
    >
      <Modal.Header title="Brivity Dialer" description={<ConferenceConfirmationDescription />} closeButton />
      <Modal.Body className="tw-overflow-x-hidden">
        <ConferenceConfirmationBody
          consentChecked={consentChecked}
          featureFlags={featureFlags}
          isAdmin={isAdmin}
          loadingValidLeads={loadingValidLeads}
          outboundNotificationMessage={outboundNotificationMessage}
          outboundNotificationMessageCondition={outboundNotificationMessageCondition}
          outboundRecording={outboundRecording}
          outboundRecordingEnabled={outboundRecordingEnabled}
          setConsentChecked={setConsentChecked}
          validLeadCounts={validLeadCounts}
        />
      </Modal.Body>
      <Modal.Footer className="tw-flex tw-justify-between">
        <ConferenceConfirmationActions
          closeConfirmation={closeConfirmationModal}
          createDialerSession={createDialerSession}
          isLoading={isLoading}
          startDisabled={startDisabled}
        />
      </Modal.Footer>
    </Modal>
  );
};

ConfirmationModal.propTypes = {
  selectedLeadUuids: PropTypes.arrayOf(PropTypes.string).isRequired,
  closeConfirmationModal: PropTypes.func.isRequired,
  createDialerSession: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default ConfirmationModal;
